/**
 * Normalize `<keySafetyNotes>` wrapper tags to lowercase before Streamdown parses.
 *
 * HTML/rehype lowercases tag names (`<keySafetyNotes>` → `keysafetynotes`), but
 * our custom renderer is registered under the lowercase name. Models emit the
 * camelCase spelling from the prompt; normalize so the block component matches.
 */
export function normalizeKeySafetyNotesTags(markdown: string): string {
  return markdown.replace(/<\/?keysafetynotes>/gi, (tag) => tag.toLowerCase());
}
